import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";

const POLL_INTERVAL_MS = 60_000;

/** Live unread-count for the Action Center sidebar badge. There is no "mark as read" concept -
 * the count always reflects currently-unresolved items for the caller's own store scope (see
 * action_center_routes.py::get_digest_count), so it naturally decrements once an item's
 * underlying condition is resolved elsewhere in the app. Polls rather than pushes to keep this
 * simple - acceptable for an internal ops tool, not a chat-style real-time feed. */
export function useActionCenterCount(enabled) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const fetchCount = () => {
      apiClient.get("/action-center/digest/count").then((r) => {
        if (!cancelled) setCount(r.data.count);
      }).catch(() => {});
    };
    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, [enabled]);

  return count;
}
